import request from '@/utils/request'
import { API } from '@/config'

/**
 * 账号密码登录
 * @param {{ account: string, password: string }} data
 */
export function accountLogin(data) {
  return request({
    url: API.accountLogin,
    method: 'post',
    data: {
      account: data.account,
      password: data.password
    }
  })
}

/**
 * 当前登录用户信息
 */
export function getUserIndex() {
  return request({
    url: API.userIndex,
    method: 'get'
  })
}
